import { useCallback, useState } from 'react'

import { Link as RouterLink } from 'react-router-dom'

import { useDomain } from '@tribeplatform/react-components/common/hooks'
import { Form } from '@tribeplatform/react-components/Form'
import { T } from '@tribeplatform/react-components/i18n'
import { processAuthResponse } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Link } from '@tribeplatform/react-ui-kit/Link'

import {
  AUTH_TYPE_FORM_KEY,
  PASSWORD_FORM_KEY,
  PLAIN_AUTH_TYPE,
  REDIRECT_PATH_FORM_KEY,
  USERNAME_FORM_KEY,
} from '../constants.js'

type Props = {
  redirectPath?: string
}

type LoginFormData = {
  usernameOrEmail: string
  password: string
}

export const LoginForm = ({ redirectPath }: Props) => {
  const { getResourceUrl } = useDomain()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const loginApiPath = getResourceUrl('/api/auth/login')

  const onSubmit = useCallback(
    async (data: LoginFormData) => {
      setIsSubmitting(true)
      try {
        await processAuthResponse(loginApiPath, data)
      } catch (e) {
        setIsSubmitting(false)
        throw e
      }
    },
    [loginApiPath],
  )
  return (
    <Form
      method="post"
      action={loginApiPath}
      onSubmit={onSubmit}
      className="space-y-5"
    >
      <Form.Input
        name={AUTH_TYPE_FORM_KEY}
        value={PLAIN_AUTH_TYPE}
        hidden
        readOnly
      />
      <Form.Input
        name={REDIRECT_PATH_FORM_KEY}
        value={redirectPath}
        hidden
        readOnly
      />
      <Form.Input
        name={USERNAME_FORM_KEY}
        label={<T defaultMessage="Email" id="Generics.Email" />}
        autoFocus
        autoComplete="email"
      />

      <Form.Input
        name={PASSWORD_FORM_KEY}
        type="password"
        label={
          <div className="flex justify-between">
            <T defaultMessage="Password" id="Generics.Password" />
            <Link as={RouterLink} to="/auth/forgot-password">
              <T
                defaultMessage="Forgot your password?"
                id="Generics.ForgotYourPassword"
              />
            </Link>
          </div>
        }
        autoComplete="current-password"
      />

      <div>
        <Button
          fullWidth
          variant="primary"
          loading={isSubmitting}
          type="submit"
          size="lg"
        >
          <T defaultMessage="Log in" id="Generics.LogIn" />
        </Button>
      </div>
    </Form>
  )
}
